import React, { useRef, useState, useCallback } from 'react';

export default function ImageUploadZone({
  onFileSelect,
  imagePreview = null,
  onClear,
  instruction = '\uc0ac\uc9c4\uc744 \ucd2c\uc601\ud558\uac70\ub098 \uc120\ud0dd\ud574\uc8fc\uc138\uc694',
  accept = 'image/*',
  capture = 'environment',
}) {
  const inputRef = useRef(null);
  const [isDragging, setIsDragging] = useState(false);

  const handleClick = () => {
    inputRef.current?.click();
  };

  const handleFile = useCallback((file) => {
    if (file && file.type.startsWith('image/')) {
      onFileSelect(file);
    }
  }, [onFileSelect]);

  const handleChange = (e) => {
    const file = e.target.files[0];
    if (file) handleFile(file);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    setIsDragging(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    setIsDragging(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setIsDragging(false);
    const file = e.dataTransfer.files[0];
    if (file) handleFile(file);
  };

  if (imagePreview) {
    return (
      <div style={{
        position: 'relative',
        borderRadius: 'var(--radius-xl, 1rem)',
        overflow: 'hidden',
        marginBottom: '1rem',
        animation: 'scaleIn 0.3s ease forwards',
      }}>
        <img
          src={imagePreview}
          alt="\ucd2c\uc601 \uc774\ubbf8\uc9c0"
          style={{
            width: '100%',
            maxHeight: '300px',
            objectFit: 'cover',
            display: 'block',
          }}
        />
        {/* Overlay with re-take / delete */}
        <div style={{
          position: 'absolute',
          bottom: 0,
          left: 0,
          right: 0,
          display: 'flex',
          gap: '0.5rem',
          padding: '0.75rem',
          background: 'linear-gradient(transparent, rgba(0,0,0,0.7))',
          justifyContent: 'center',
        }}>
          <button
            onClick={(e) => { e.stopPropagation(); handleClick(); }}
            style={{
              padding: '0.5rem 1rem',
              background: 'rgba(255,255,255,0.2)',
              backdropFilter: 'blur(8px)',
              WebkitBackdropFilter: 'blur(8px)',
              color: 'white',
              border: '1px solid rgba(255,255,255,0.3)',
              borderRadius: 'var(--radius-full, 9999px)',
              cursor: 'pointer',
              fontSize: '0.8rem',
              fontWeight: 600,
            }}
          >
            \ud83d\udcf7 \uc7ac\ucd2c\uc601
          </button>
          {onClear && (
            <button
              onClick={(e) => { e.stopPropagation(); onClear(); }}
              style={{
                padding: '0.5rem 1rem',
                background: 'rgba(220, 53, 69, 0.8)',
                color: 'white',
                border: 'none',
                borderRadius: 'var(--radius-full, 9999px)',
                cursor: 'pointer',
                fontSize: '0.8rem',
                fontWeight: 600,
              }}
            >
              \u2715 \uc0ad\uc81c
            </button>
          )}
        </div>
        <input
          ref={inputRef}
          type="file"
          accept={accept}
          capture={capture}
          onChange={handleChange}
          style={{ display: 'none' }}
        />
      </div>
    );
  }

  return (
    <div
      onClick={handleClick}
      onDragOver={handleDragOver}
      onDragLeave={handleDragLeave}
      onDrop={handleDrop}
      style={{
        border: `2px dashed ${isDragging ? 'var(--color-accent, #667eea)' : '#d0d5dd'}`,
        borderRadius: 'var(--radius-xl, 1rem)',
        padding: '2.5rem 1.5rem',
        textAlign: 'center',
        cursor: 'pointer',
        transition: 'all var(--transition-normal, 250ms)',
        background: isDragging ? 'rgba(102, 126, 234, 0.05)' : 'var(--color-surface-dim, #f8f9fa)',
        marginBottom: '1rem',
      }}
    >
      <div style={{
        fontSize: '3rem',
        marginBottom: '0.75rem',
        opacity: 0.6,
      }}>
        \ud83d\udcf7
      </div>
      <p style={{
        fontSize: '0.95rem',
        color: 'var(--color-text-secondary, #666)',
        fontWeight: 500,
        marginBottom: '0.35rem',
      }}>
        {instruction}
      </p>
      <p style={{
        fontSize: '0.8rem',
        color: 'var(--color-text-muted, #999)',
      }}>
        \ud0ed\ud558\uc5ec \ucd2c\uc601\ud558\uac70\ub098 \uc774\ubbf8\uc9c0\ub97c \ub4dc\ub798\uadf8\ud574\uc8fc\uc138\uc694
      </p>
      <input
        ref={inputRef}
        type="file"
        accept={accept}
        capture={capture}
        onChange={handleChange}
        style={{ display: 'none' }}
      />
    </div>
  );
}
